import React, { Component } from 'react';

class ToggleSwitch extends Component {
  render() {
    return (
      <div className="form-group">
        <label className="col-md-4 control-label">{this.props.fieldName}</label>
        <div className="col-md-8">
          <label className="toggleSwitch">
            <input 
              id={this.props.id}
              disabled={this.props.disabled}
              value={this.props.id}
              type="checkbox"
              onChange={this.props.handleChange}
              onClick={this.props.handleChange}
              checked={this.props.values[this.props.id]}
            />
            <span className="toggleSwitchSlider"></span>
          </label>
        </div>
      </div>
    );
  }
}

export default ToggleSwitch;


// WEBPACK FOOTER //
// ./src/Components/Form/ToggleSwitch.js